import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// PWA: Register service worker after page load to avoid chaining critical requests
const registerPWA = () => {
  if (!("serviceWorker" in navigator)) return;

  const isInIframe = (() => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  })();

  const isPreviewHost =
    window.location.hostname.includes("id-preview--") ||
    window.location.hostname.includes("lovableproject.com");

  if (isPreviewHost || isInIframe) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((r) => r.unregister());
    });
  } else {
    let reloading = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });

    import("virtual:pwa-register").then(({ registerSW }) => {
      const updateSW = registerSW({
        immediate: true,
        onRegisteredSW(_swUrl, r) {
          if (!r) return;
          const checkForUpdate = () => r.update().catch(() => {});
          checkForUpdate();
          // Poll every 5 minutes
          setInterval(checkForUpdate, 5 * 60 * 1000);
          // Check when tab becomes visible
          document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") checkForUpdate();
          });
          // Check when browser regains connectivity
          window.addEventListener("online", checkForUpdate);
          if (r.waiting) r.waiting.postMessage({ type: "SKIP_WAITING" });
        },
        onNeedRefresh() {
          window.dispatchEvent(new CustomEvent("pwa-update-available"));
          (window as any).__pwaUpdate = updateSW;
          updateSW(true);
        },
      });
    });
  }
};

// Defer PWA registration until after the page has loaded
if (document.readyState === "complete") {
  registerPWA();
} else {
  window.addEventListener("load", registerPWA, { once: true });
}

createRoot(document.getElementById("root")!).render(<App />);
